<template>
  <div>
    <ClientOnly>
      <VuepalTransitionHeight opacity>
        <LazyAndroidSmartBanner
          v-if="showSmartBanner"
          @close="hasClosedSmartbanner = true"
        />
      </VuepalTransitionHeight>
    </ClientOnly>

    <NuxtPageDependency v-if="pageRendered">
      <AppHeader />
    </NuxtPageDependency>

    <NuxtPageDependency v-if="pageRendered">
      <VuepalBreadcrumb v-slot="{ links }">
        <VuepalTransitionHeight
          :duration="200"
          :easing-enter="EASE_SWING"
          :easing-leave="EASE_SWING"
        >
          <Breadcrumb v-if="!hideBreadcrumb" :links="links" />
        </VuepalTransitionHeight>
      </VuepalBreadcrumb>
    </NuxtPageDependency>

    <div class="page-wrapper min-h-[80vh]">
      <ClientOnly>
        <DrupalMessages v-if="!isEditing" />
      </ClientOnly>

      <NuxtPage />
    </div>

    <NuxtPageDependency v-if="pageRendered">
      <AppFooter :channel="activeChannel" />
    </NuxtPageDependency>
  </div>
</template>

<script setup lang="ts">
import { useLocalStorage } from '@vueuse/core'
import { EASE_SWING } from '~~/settings/tailwind'

const route = useRoute()
const user = await useDrupalUser()
const language = useCurrentLanguage()
const { isUntilDesktop } = useViewport()
const { activeChannel, isChannelLandingPage } = useSiteContext()
const { pageRendered } = usePageDependencies()

const isAndroid = computed(() => {
  if (import.meta.client) {
    return /(android)/i.test(navigator.userAgent)
  }
  return false
})

const hasClosedSmartbanner = useLocalStorage('hasClosedSmartbanner', false)

const showSmartBanner = computed(
  () => isAndroid.value && !hasClosedSmartbanner.value && isUntilDesktop.value,
)

const isEditing = computed(
  () =>
    !!(route.query.blokkliEditing || route.query.blokkliPreview) &&
    user.canAccessToolbar,
)

const hideBreadcrumb = computed(
  () => route.meta.hideBreadcrumb || isChannelLandingPage(route.path),
)

useHead({
  htmlAttrs: {
    lang: language.value,
  },
})
</script>

<style>
.page-wrapper {
  counter-reset: count;
}
</style>
